import cartDropdownContentHtml from './cartdropdowncontent.component.html';
import priceTypeService from "../price/priceType.service";

class CartDropdownContentController {
    constructor($scope, $document, cartService, translateService, priceTypeService, $sce) {
        'ngInject';

        this.$scope = $scope;
        this.$document = $document;
        this.$sce = $sce;
        this.service = cartService;
        this.translate = translateService;
        this.priceType = priceTypeService;
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load();
        }
    }

    trustedHtml(html) {
        return this.$sce.trustAsHtml(html);
    }

    get cartUrl() {
        return this.translate.translate('checkout.routes.cart');
    }

}

let cartDropdownContentComponent = {
    bindings: {
        loadOn: '@'
    },
    template: cartDropdownContentHtml,
    controller: CartDropdownContentController
}

export default cartDropdownContentComponent;
